package er.prateek.crossly.share

expect fun shareText(text: String)

expect fun startInstallReferrerCapture(onResult: (referrer: String?) -> Unit)

expect fun isWebRuntime(): Boolean

expect fun currentPageUrl(): String

expect fun openExternalUrl(url: String)

expect fun browserEnvironment(): BrowserEnvironment

data class BrowserEnvironment(
    val userAgent: String = "",
    val language: String = "",
    val documentReferrer: String = "",
    val viewportWidth: Int = 0,
    val viewportHeight: Int = 0,
    val timezoneOffsetMinutes: Int = 0,
)
